<template>
    <v-card class="ma-4 px-4" style="height: calc(100% - 36px);" outlined :loading="loading">
        <v-card-title>
            <v-icon class="mr-2">mdi-comment-outline</v-icon>
            Comment List
            <v-spacer></v-spacer>
            <v-btn color="green" dark class="mr-2" @click="refreshData">
                <v-icon left>mdi-refresh</v-icon>
                Refresh
            </v-btn>
            <v-btn color="primary" class="mr-2" @click="checkMany">
                <v-icon left>mdi-comment-check-outline</v-icon>
                Check
            </v-btn>
            <v-btn color="orange" dark @click="deleteManyDialogShow = true">
                <v-icon left>mdi-comment-remove-outline</v-icon>
                Delete
            </v-btn>
        </v-card-title>
        <v-data-table v-model="selectedComments" :headers="headers" :items="commentList" :items-per-page="20" item-key="ID" show-select @click:row="viewComment">
            <template v-slot:item.WebsiteURL="{ item }">
                <a :href="item.Website" target="_blank">{{ item.Website }}</a>
            </template>
            <template v-slot:item.NicknameEmail="{ item }">
                {{ item.Nickname }}|<a :href="'mailto:' + item.Email">{{ item.Email }}</a>
            </template>
            <template v-slot:item.ShowStateIcon="{ item }">
                <v-icon :color="item.showStateColor">{{ item.icon }}</v-icon>
            </template>
            <template v-slot:item.Control="{ item }">
                <v-btn icon color="primary" v-if="item.Show == false" @click.stop="checkComment(item)">
                    <v-icon>mdi-comment-check</v-icon>
                </v-btn>
                <v-btn icon color="orange" @click.stop="showDeleteDialog(item)">
                    <v-icon>mdi-comment-remove</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <v-dialog v-model="deleteDialogShow" max-width="500">
            <v-card>
                <v-card-title class="headline warning lighten-2 mb-4">Delete the comment Forever?</v-card-title>
                <v-card-text class="subtitle-1 black--text"> Content: {{ viewedComment.Content }}<br />Will be deleted Forver, Sure?</v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" text @click="deleteDialogShow = false">
                        No
                    </v-btn>
                    <v-btn color="warning" text @click="deleteComment">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteManyDialogShow" max-width="500">
            <v-card>
                <v-card-title class="headline warning lighten-2 mb-4">Delete the comments Forver?</v-card-title>
                <v-card-text class="subtitle-1 black--text"> The comments you selected will be deleted Forver, Sure?</v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" text @click="deleteDialogShow = false">
                        No
                    </v-btn>
                    <v-btn color="warning" text @click="deleteMany">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="viewedCommentDialogShow" max-width="500">
            <v-card>
                <v-card-title class="headline primary lighten-2 mb-4">Comment View</v-card-title>
                <v-card-text class="subtitle-1 black--text">
                    <v-row>
                        <v-col cols="4">Nickname:</v-col>
                        <v-col cols="8">{{ viewedComment.Nickname }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">Email:</v-col>
                        <v-col cols="8">{{ viewedComment.Email }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">About He:</v-col>
                        <v-col cols="8">{{ viewedComment.AboutHe }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">Website:</v-col>
                        <v-col cols="8">{{ viewedComment.Website }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">Article:</v-col>
                        <v-col cols="8">{{ viewedComment.ArticleTitle }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">Content:</v-col>
                        <v-col cols="8">{{ viewedComment.Content }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">Browser UUID:</v-col>
                        <v-col cols="8">{{ viewedComment.BrowserID }}</v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" text @click="viewedCommentDialogShow = false">
                        Close
                    </v-btn>
                    <v-btn color="primary" @click="checkComment(viewedComment)" v-if="viewedComment.Show == false"> <v-icon>mdi-comment-check</v-icon>Check </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { Log } from "../../utils/debug";
import { apiDeleteComments, apiGetCommentList, apiCheckComments } from "../../api/comment";
import { removeUnitFromListWithID } from "../../utils/utils";

export default {
    name: "CommentList",
    data: () => ({
        loading: true,
        headers: [
            {
                text: "Content",
                align: "left",
                sortable: false,
                value: "Content"
            },
            { text: "Nickname|Email", value: "NicknameEmail", sortable: false },
            { text: "Website", value: "WebsiteURL", sortable: false },
            { text: "Show", value: "ShowStateIcon", sortable: false },
            { text: "Control", value: "Control", align: "center", sortable: false, width: 105 }
        ],
        commentList: [],
        selectedComments: [],
        viewedComment: {},
        deleteDialogShow: false,
        deleteManyDialogShow: false,
        viewedCommentDialogShow: false
    }),
    mounted() {
        this.refreshData();
    },
    methods: {
        refreshData() {
            this.loading = true;
            apiGetCommentList()
                .then(resp => {
                    Log.debug(resp);
                    this.commentList = resp.data;
                    for (let i = 0; i < this.commentList.length; i++) {
                        if (this.commentList[i].Show) {
                            this.commentList[i].icon = "mdi-comment-check";
                            this.commentList[i].showStateColor = "primary";
                        } else {
                            this.commentList[i].icon = "mdi-comment-question";
                            this.commentList[i].showStateColor = "grey";
                        }
                    }

                    this.loading = false;
                })
                .catch(err => {
                    Log.error(err);
                });
        },
        showDeleteDialog: function(item) {
            Log.debug(item);
            this.viewedComment = item;
            this.deleteDialogShow = true;
        },
        deleteComment: function() {
            apiDeleteComments([this.viewedComment.ID]).then(() => {
                removeUnitFromListWithID(this.commentList, this.viewedComment);
                this.deleteDialogShow = false;
            });
        },
        viewComment(value) {
            this.viewedComment = value;
            this.viewedCommentDialogShow = true;
        },
        checkComment: function(item) {
            Log.debug(item);
            apiCheckComments([item.ID]).then(() => {
                item.Show = true;
                item.icon = "mdi-comment-check";
                item.showStateColor = "primary";
                if (this.viewedCommentDialogShow) this.viewedCommentDialogShow = false;
            });
        },
        checkMany() {
            let ids = [];
            for (let i = 0; i < this.selectedComments.length; i++) {
                ids.push(this.selectedComments[i].ID);
            }
            apiCheckComments(ids).then(() => {
                for (let i = 0; i < this.selectedComments.length; i++) {
                    this.selectedComments[i].Show = true;
                    this.selectedComments[i].icon = "mdi-comment-check";
                    this.selectedComments[i].showStateColor = "primary";
                }
            });
        },
        deleteMany() {
            let ids = [];
            for (let i = 0; i < this.selectedComments.length; i++) {
                ids.push(this.selectedComments[i].ID);
            }
            apiDeleteComments(ids).then(() => {
                removeUnitFromListWithID(this.commentList, this.selectedComments);
                this.selectedComments = [];
                this.deleteManyDialogShow = false;
            });
        }
    }
};
</script>

<style scoped></style>
